import React from 'react';
import styled from 'styled-components';

import { FlexDiv } from '../base/Div';
import ColorConstants from '../../constants/ColorConstants';

const defaultProps = {
    children: null,
    className: null,
    styles: null,
};

const RoundedSquare = ({
    className, children, styles, ...props
}) => (
    <Wrapper className={className} styles={styles} {...props}>{children}</Wrapper>
);

const Wrapper = styled(FlexDiv)`
    align-items: center;
    background-color: ${ColorConstants['catskill-white']};
    border-radius: 99px;
    height: 33px;
    width: 110px;
     ${({ styles }) => styles && { ...styles }};
`;

RoundedSquare.defaultProps = defaultProps;

export default RoundedSquare;
